import React from 'react';
import {
  Sun, BarChart3, Target, Activity,
  Zap, Globe, Settings,
} from 'lucide-react';
import ServicePage from '../../components/enterprise/ServicePage';

const SolarEnergyFarmPage = () => (
  <ServicePage
    hero={{
      eyebrow: 'Solar Energy Farm Solutions',
      title: (
        <>
          Advanced solar energy <em>monitoring and optimization</em>
        </>
      ),
      lede: 'Advanced solar energy monitoring and optimization systems for maximum efficiency and performance of large-scale solar energy farms and installations.',
      image: '/assets/img/general/solar-8244680_1280.jpg',
      imageAlt: 'Large-scale solar energy farm',
      actions: [
        { label: 'Start solar optimization', to: '/contact' },
        { label: 'View solar cases', to: '/case-studies' },
      ],
      metrics: [
        { value: '30%', label: 'Efficiency increase' },
        { value: '25%', label: 'Cost reduction' },
        { value: '99.8%', label: 'Uptime' },
        { value: '24/7', label: 'Monitoring' },
      ],
    }}
    overview={{
      eyebrow: 'Overview',
      title: 'Advanced solar farm management',
      lede: 'Our comprehensive solar energy solutions provide complete monitoring and optimization for large-scale solar farms, ensuring maximum efficiency and performance.',
      checklist: [
        'Maximize solar energy output by 20-30%',
        'Reduce operational costs by 25%',
        'Improve solar panel efficiency by 15%',
        'Enable predictive maintenance for solar farms',
      ],
      image: '/assets/img/general/photovoltaic-system-2742302_1280.jpg',
      imageAlt: 'Photovoltaic system at utility scale',
      imageCaption: 'Panel, string, inverter and grid interface — managed as one system',
    }}
    capabilities={{
      eyebrow: 'Key features & benefits',
      title: 'Comprehensive solar energy solutions',
      lede: 'Designed to maximize farm performance.',
      items: [
        {
          icon: Sun,
          title: 'Solar farm monitoring',
          description: 'Comprehensive monitoring of large-scale solar energy farms and installations.',
        },
        {
          icon: BarChart3,
          title: 'Performance analytics',
          description: 'Advanced analytics to track and optimize solar farm performance metrics.',
        },
        {
          icon: Target,
          title: 'Efficiency optimization',
          description: 'AI-driven optimization to maximize solar energy generation and efficiency.',
        },
        {
          icon: Activity,
          title: 'Real-time management',
          description: 'Real-time monitoring and management of solar farm operations.',
        },
      ],
    }}
    coverage={{
      eyebrow: 'Comprehensive solar solutions',
      title: 'Complete farm coverage',
      lede: 'Complete solar energy farm monitoring and optimization solutions.',
      items: [
        {
          icon: Sun,
          title: 'Solar panel monitoring',
          description: 'Individual and array-level monitoring of solar panel performance.',
        },
        {
          icon: Zap,
          title: 'Inverter management',
          description: 'Comprehensive monitoring and optimization of solar inverters.',
        },
        {
          icon: Globe,
          title: 'Weather integration',
          description: 'Weather data integration for accurate solar forecasting.',
        },
        {
          icon: Settings,
          title: 'Grid integration',
          description: 'Seamless integration with electrical grid systems.',
        },
      ],
    }}
    cta={{
      title: "Ready to optimize your solar farm?",
      body: "Discover how our solar energy solutions can maximize your farm's performance.",
      primary: { label: 'Start solar optimization', to: '/contact' },
      secondary: { label: 'View solar cases', to: '/case-studies' },
    }}
  />
);

export default SolarEnergyFarmPage;
